<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/ata-rangi')">Ata Rangi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/bell-hill-vineyards')">Bell Hill Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/craggy-range')">Craggy Range
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/dog-point-vineyards')">Dog Point Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/millton-vineyards-and-winery')">Millton
                        Vineyards and Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/pyramid-valley-vineyards')">Pyramid Valley
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/new-zealand/rippon-vineyards')">Rippon Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/trinity-hill')">Trinity Hill
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Rippon Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        I primi anni '70 videro l'inizio di una nuova frontiera mondiale del vino per la Nuova Zelanda. Casa del superlativo Lord of
                        il paesaggio degli Anelli, molta vitalità e un intero carico di visione, terra che una volta era considerata
                        “buon paese merino”, divenne proprietà di “quei vignaioli”.
                    </div>

                    <div class="howto-title2">Risultato positivo</div>
                    <div class="howto-text">
                        I Rippon in realtà hanno iniziato la loro vita, non in Nuova Zelanda, ma in Australia. Emma Rippon è emigrata
                        a Oz dal Regno Unito a metà del XIX secolo, quando veniva acclamato come una terra promessa. Tramontano
                        su una piccola attività di vendita familiare che ha visto gli uomini viaggiare in tutto il paese e alla fine a
                        Nuova Zelanda. All'arrivo a Dunedin, nell'Isola del Sud, Percy Sarwood, nipote di Emma, acquistò Wanaka
                        Stazione, che divenne l'azienda agricola di famiglia. Era il 1912 e la terra era rimasta più o meno così
                        fu per i successivi 60 anni. Tuttavia, ha portato a una crescente realizzazione della nuova industria vinicola mondiale
                        Rolfe Mills (nipote di Percy e grande, grande, grande, grande nipote di Emma) per studiare il
                        suolo e clima e piantare alcune viti di prova iniziali con Pinot Nero, Riesling, Gewurztraminer
                        &amp; Sauvignon Blanc nel 1982. Subentrato al padre nel xxxx, Nick Mills (l'ex
                        Sciatore olimpico) ha davvero portato i vini in proprio, e oggi Rippon è in crescita
                        delizia per gli appassionati.
                        <br><br>
                        Di proprietà e gestione familiare, il pionieristico vigneto boutique ha forse i luoghi più belli
                        in Central Otago, sposato dagli elementi: lunghe ore di sole, clima temperato e
                        roccia madre metamorfica. Dolci pendii conducono al lago Wanaka.
                    </div>

                    <div class="howto-title2">Raddoppia i tuoi soldi</div>
                    <div class="howto-text">
                        Rippon ha alcuni dei vigneti più antichi della regione del nuovo mondo e i loro vini premium dalle loro viti di prova sono tra i migliori in Nuova Zelanda. Il Rippon, Mature Vine Pinot Noir 2008 Central Otago è uno dei migliori; uscito a 30 euro nel 2011, il vino ha mostrato un enorme potenziale e dieci anni dopo ha raddoppiato il prezzo. A differenza di molti altri vini del nuovo mondo che sono appena agli inizi, Rippon mostra un approccio adulto che vale la pena guardare.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Rippon Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        In den frühen 1970er Jahren begann für Neuseeland eine neue Weinregion. Heimat des Superlativherrn von
                        die Ringe-Landschaft, viel Lebendigkeit und eine ganze Menge Visionen, Land, das einst in Betracht gezogen wurde
                        „gutes Merinoland“, ging in den Besitz „dieser Winzer“ über.
                    </div>

                    <div class="howto-title2">Test positiv</div>
                    <div class="howto-text">
                        Die Existenz der Rippon begann tatsächlich nicht in Neuseeland, sondern in Australien. Emma Rippon ist ausgewandert
                        Mitte des 19. Jahrhunderts aus Großbritannien nach Oz, als es als gelobtes Land gefeiert wurde. Sie setzen
                        gründete ein kleines Familienverkaufsunternehmen, bei dem die Männer durch das ganze Land und schließlich auch dorthin reisten
                        Neuseeland. Bei der Ankunft in Dunedin auf der Südinsel kaufte Percy Sarwood, Emmas Enkel, Wanaka
                        Station, die zum Familienbauernhof wurde. Das war im Jahr 1912, und das Land blieb mehr oder weniger unverändert
                        es war für die nächsten 60 Jahre. Allerdings führte dies zu einer zunehmenden Erkenntnis der neuen Welt der Weinindustrie
                        Rolfe Mills (Percys Enkel und Emmas Ur-Ur-Ur-Ur-Enkel) soll das studieren
                        Erkunden Sie Boden und Wetter und pflanzen Sie erste Testreben mit Pinot Noir, Riesling und Gewürztraminer
                        &amp; Sauvignon Blanc im Jahr 1982. Nachfolger seines Vaters in xxxx, Nick Mills (der erstere).
                        (Olympia-Skifahrer) hat die Weine wirklich zur Geltung gebracht, und heute erfreut sich Rippon einer wachsenden Beliebtheit
                        Freude für Enthusiasten.
                        <br><br>
                        Der bahnbrechende Boutique-Weinberg ist in Familienbesitz und wird von einer Familie betrieben. Er verfügt über die vielleicht schönsten Orte
                        in Zentral-Otago, begünstigt durch die Elemente: lange Sonnenstunden, gemäßigtes Klima und vieles mehr
                        metamorphes Muttergestein. Sanfte Steigungen führen hinunter zum Lake Wanaka.
                    </div>

                    <div class="howto-title2">Verdoppeln Sie Ihr Geld</div>
                    <div class="howto-text">
                        Rippon verfügt über einige der ältesten Weinreben der Region der Neuen Welt und die Premiumweine aus den Testreben gehören zu den besten Neuseelands. Der Rippon, Mature Vine Pinot Noir 2008 Central Otago ist einer ihrer besten; Der Wein, der 2011 für 30 Euro auf den Markt kam, zeigte großes Potenzial und zehn Jahre später hat sich sein Preis verdoppelt. Im Gegensatz zu vielen anderen Weinen aus der Neuen Welt, die gerade erst am Anfang stehen, zeigt Rippon einen erwachsenen Ansatz, der es wert ist, beobachtet zu werden.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Rippon Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Le début des années 1970 a vu une nouvelle frontière mondiale du vin commencer pour la Nouvelle-Zélande. Maison du superlatif Seigneur de
                        le paysage des Anneaux, beaucoup de vitalité et toute une charge de vision, une terre qui était autrefois considérée
                        "bon pays mérinos", est devenu la propriété de "ces vignobles".
                    </div>

                    <div class="howto-title2">Test positif</div>
                    <div class="howto-text">
                        Les Rippon ont en fait commencé leur vie, non pas en Nouvelle-Zélande, mais en Australie. Emma Rippon a émigré
                        à Oz du Royaume-Uni au milieu du 19e siècle, alors qu'il était salué comme une terre promise. Ils ont mis
                        monter une petite entreprise familiale de vente qui a vu les hommes voyager dans tout le pays et finalement
                        NZ. À son arrivée à Dunedin, sur l'île du Sud, Percy Sarwood, le petit-fils d'Emma, a acheté Wanaka
                        Gare, devenue la ferme familiale. C'était en 1912, et la terre a été laissée plus ou moins comme
                        c'était pour les 60 prochaines années. Cependant, une prise de conscience croissante de la nouvelle industrie mondiale du vin a conduit
                        Rolfe Mills (petit-fils de Percy et arrière, arrière, arrière, arrière, petit-fils d'Emma) pour étudier le
                        sol et météo et planter quelques premières vignes d'essai avec du Pinot Noir, du Riesling, du Gewurztraminer
                        &amp; Sauvignon Blanc en 1982. Succédant à son père en xxxx, Nick Mills (l'ancien
                        skieur olympique) a vraiment mis les vins en valeur, et aujourd'hui Rippon est de plus en plus
                        ravir les passionnés.
                        <br><br>
                        Détenu et exploité par une famille, le vignoble boutique pionnier a peut-être les plus beaux endroits
                        dans le Central Otago, épousé par les éléments : longues heures d'ensoleillement, climat tempéré et
                        roche mère métamorphique. Des pentes douces mènent au lac Wanaka.
                    </div>

                    <div class="howto-title2">Doublez votre argent</div>
                    <div class="howto-text">
                        Rippon possède certaines des plus anciennes vignes de la région du nouveau monde et leurs vins haut de gamme issus de leurs vignes d'essai sont parmi les meilleurs de Nouvelle-Zélande. Le Rippon, Mature Vine Pinot Noir 2008 Central Otago est l'un de leurs meilleurs; Sorti à 30 € en 2011, le vin a montré un énorme potentiel et dix ans plus tard, il a doublé de prix. Contrairement à de nombreux autres vins du nouveau monde qui ne font que commencer, Rippon montre une approche adulte qui vaut la peine d'être observée.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Rippon Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        The early 1970s saw a new world wine frontier begin for New Zealand. Home of superlative Lord of
                        the Rings landscape, much vitality and a whole load of vision, land that was once considered
                        “good merino country”, became the property of “those wineys”.
                    </div>

                    <div class="howto-title2">Testing positive</div>
                    <div class="howto-text">
                        The Rippon’s actually started life, not in New Zealand, but in Australia. Emma Rippon emigrated
                        to Oz from the UK in the mid 19th century, when it was being hailed as a promised land. They set
                        up a small family sales business which saw the men travel all over the country and eventually to
                        NZ. Upon arrival in Dunedin, South Island, Percy Sarwood, Emma&#39;s grandson bought Wanaka
                        Station, which became the family farm. That was in 1912, and the land was left more or less as
                        it was for the next 60 years. However, a growing realisation of the new world wine industry led
                        Rolfe Mills (Percy’s grandson and Emma&#39;s great, great, great, great, grandson) to study the
                        soil and weather and plant some initial test vines with Pinot Noir, Riesling, Gewurztraminer
                        &amp; Sauvignon Blanc in 1982. Taking over from his father in xxxx, Nick Mills (the former
                        Olympic skier) has really brought the wines into their own, and today Rippon is an increasing
                        delight for enthusiasts.
                        <br><br>
                        Family owned and operated, the pioneering boutique vineyard has perhaps the most beautiful spots
                        in Central Otago, espoused by the elements: long sunshine hours, temperate climate and
                        metamorphic mother rock. Gentle slopes lead down to Lake Wanaka.
                    </div>

                    <div class="howto-title2">Double your money</div>
                    <div class="howto-text">
                        Rippon has some of the oldest vines of the new world region and their premium wines from their test vines are some of the best in New Zealand. The Rippon, Mature Vine Pinot Noir 2008 Central Otago is one of their best; released at €30 in 2011, the wine showed huge potential and ten years later it has doubled in price. Unlike many other new world wines that are just getting started, Rippon shows a grown-up approach that is worth watching.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RipponVineyards",
    data() {
        return {
            select: {report: 'Rippon Vineyards', src: '/wine-guide/new-zealand/rippon-vineyards'},
            items: [
                {report: 'Ata Rangi', src: '/wine-guide/new-zealand/ata-rangi'},
                {report: 'Bell Hill Vineyards', src: '/wine-guide/new-zealand/bell-hill-vineyards'},
                {report: 'Craggy Range', src: '/wine-guide/new-zealand/craggy-range'},
                {report: 'Dog Point Vineyards', src: '/wine-guide/new-zealand/dog-point-vineyards'},
                {report: 'Millton Vineyards and Winery', src: '/wine-guide/new-zealand/millton-vineyards-and-winery'},
                {report: 'Pyramid Valley Vineyards', src: '/wine-guide/new-zealand/pyramid-valley-vineyards'},
                {report: 'Rippon Vineyards', src: '/wine-guide/new-zealand/rippon-vineyards'},
                {report: 'Trinity Hill', src: '/wine-guide/new-zealand/trinity-hill'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Rippon Vineyards | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the unique and exceptional wines from Rippon Vineyards, a leading wine producer in New Zealand\'s Central Otago region known for its exceptional terroir and winemaking expertise.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
